import React from "react";
import { useState, useEffect } from "react";
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from "@mui/material";
import { Toolbar } from "@mui/material";
import { IconButton } from "@mui/material";
import { Button, Box, Paper, Typography, TextField, CircularProgress, AppBar } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { List } from "@mui/material";
import { Tooltip } from "@mui/material";
import CreateIcon from "@mui/icons-material/Create";
import {
  ApiGet,
  ApiPost,
  ApiPut,
  ApiDelete,
} from "../helpers/API/ApiData";
import { getUploadErrorMessage } from "../helpers/uploadErrorMessage";
import DeleteIcon from "@mui/icons-material/Delete";
import { toast, ToastContainer } from "react-toastify";
import InfoIcon from "@mui/icons-material/Info";
import { DataTable, TableColumnDef } from "../components/DataTable";
import { TableThumbnail } from "../components/TableThumbnail";
import { SelfHostedEditor } from "../components/TextEditor";
import { SearchInput } from "../components/SearchInput";
import { usePermissions } from "../hooks/usePermissions";
import { PageHeader } from "../components/PageHeader";
import { useImageCrop } from "../hooks";
import { ImageCropField } from "../components/ImageCropField";
import { useContentLanguage } from "../hooks";
import { LanguageTabs } from "../components/LanguageTabs";

interface EditorStateData {
  contentData: string;
  content: string;
  content1: string;
  contentData1: string;
}

export default function Challenges() {
  // Permission-based access control
  const { canCreate, canEdit, canDelete } = usePermissions("/challenges");

  const [Challenges, setChallenges] = useState<any>({}) as any;
  // const [Challenges, setChallengesData] = useState<any>() as any;
  const [addChallenges, setAddChallenges] = useState(false);
  const [userDetails, setUserDetails] = useState(false);
  const [errors, setErrors] = useState<any>({});
  const [getAllChallenges, setGetAllChallenges] = useState<any[]>([]);
  const [modalCountPerPage, setModalCountPerPage] = useState(10);
  const [modalPage, setModalPage] = useState(1);
  const [modalCount, setModalCount] = useState(0);
  const [userData, setUserData] = useState<any>();
  const [isEditApi, setIsEditApi] = useState(false);
  const [userScore, setUserScore] = useState<any>();
  //for pagation
  const [search, setSearch] = useState<any>();
  const [search1, setSearch1] = useState<any>();
  const [getChallengeId, setgetChallengeId] = useState("");
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  const [ChallengesIdForEdit, setChallengesIdForEdit] = useState<any>();
  const [ChallengesIdForDelete, setChallengesIdForDelete] = useState<any>();
  const [countPerPage, setCountPerPage] = useState(10);
  const [loader, setLoader] = useState(false);
  const [loaderForGetAll, setLoaderForGetAll] = useState(false);
  const [modalLoading, setModalLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [id, setId] = useState("");

  const [editorState, setEditorState] = useState<EditorStateData>({
    content: "",
    contentData: "",
    content1: "",
    contentData1: "",
  });

  const [lang, setLang] = useContentLanguage();

  const imageCropEn = useImageCrop();
  const imageCropGer = useImageCrop();
  const [removeImageEn, setRemoveImageEn] = useState(false);
  const [removeImageGer, setRemoveImageGer] = useState(false);

  //For get all document
  useEffect(() => {
    getAllChallengesData();
  }, [page, countPerPage, search]);

  //For close company model
  const addChallengesModelClose = () => {
    setAddChallenges(false);
    setIsEditApi(false);
    setErrors({});
    setChallenges({});
    setEditorState({
      content: "",
      content1: "",
      contentData: "",
      contentData1: "",
    });

    imageCropEn.reset();
    imageCropGer.reset();
    setRemoveImageEn(false);
    setRemoveImageGer(false);
  };

  const userDetailsModalClose = () => {
    setUserDetails(false);
    setId("");
    setModalPage(1);
    setModalCount(0);
    setSearch1(undefined);
    setUserData(undefined);
  };


  const onhandleChange = (e: any) => {
    const { name, value } = e.target;
    setChallenges({ ...Challenges, [name]: value });
    setErrors({ ...errors, [name]: "" });
  };

  //Form validation
  const formValidation = () => {
    let formIsValid = true;
    const err: any = {};

    if (!Challenges?.name?.trim() || Challenges?.name === "") {
      formIsValid = false;
      err["name"] = "*Bitte geben Sie den Namen ein";
    }
    if (!Challenges?.name_ger?.trim() || !Challenges?.name_ger) {
      formIsValid = false;
      err["name_ger"] = "*Bitte geben Sie den Namen ein";
    }
    if (!imageCropEn.imageToUpload && !Challenges?.image) {
      formIsValid = false;
      err["image"] = "*Bitte wählen Sie ein Bild aus";
    }
    if (!imageCropGer.imageToUpload && !Challenges?.image_ger) {
      formIsValid = false;
      err["image_ger"] = "*Bitte wählen Sie ein Bild aus";
    }
    if (!Challenges?.score || Challenges?.score === "") {
      formIsValid = false;
      err["score"] = "*Bitte geben Sie die Punktzahl ein";
    }
    if (!Challenges?.reward || Challenges?.reward === "") {
      formIsValid = false;
      err["reward"] = "*Bitte geben Sie die Belohnung ein";
    }
    if (!editorState?.contentData1) {
      formIsValid = false;
      err["contentData1"] = "*Bitte geben Sie den Beschreibung ein";
    }

    // Check content1 field
    if (!editorState?.content1) {
      formIsValid = false;
      err["content1"] = "*Bitte geben Sie den Beschreibung ein";
    }

    // Check content field
    if (!editorState.content) {
      formIsValid = false;
      err["content"] = "*Bitte geben Sie den Beschreibung ein";
    }

    // Check contentData field
    if (!editorState.contentData) {
      formIsValid = false;
      err["contentData"] = "*Bitte geben Sie den Beschreibung ein";
    }
    setErrors(err);
    return formIsValid;
  };

  const handleClose = () => {
    setShow(false);
  };

  useEffect(() => {
    if (id) {
      getUserdetails(id, modalPage, modalCountPerPage, search1);
    }
  }, [id, modalPage, modalCountPerPage, search1]);

  const getUserdetails = async (
    id: any,
    detailPage: number,
    detailLimit: number,
    val: string
  ) => {
    setModalLoading(true);
    const searchParam = val?.length > 0 ? `&search=${search1}` : "";
    await ApiGet(
      `challenges/getChallengeForAdmin?id=${id}&page=${detailPage}&limit=${detailLimit}${searchParam}`
    )
      .then((res: any) => {
        setUserData(res?.data?.data?.userChallenge);
        setModalCount(res?.data?.data?.count ?? 0);
      })
      .catch(() => {})
      .finally(() => {
        setModalLoading(false);
      });
  };

  const getAllChallengesData = async () => {
    setLoaderForGetAll(true);
    const params = `page=${page}&limit=${countPerPage}${search ? `&letter=${search}` : ""}`;
    await ApiGet(`challenges/find?${params}`)
      .then((res: any) => {
        setGetAllChallenges(res?.data?.data?.data);
        setCount(res?.data?.data?.count ?? 0);
        setLoaderForGetAll(false);
      })
      .catch(() => {
        setLoaderForGetAll(false);
      });
  };

  const addCategoryData = async () => {
    setIsEditApi(false);
    if (formValidation()) {
      setLoader(true);
      try {
        const formData = new FormData();
        formData.append("name", Challenges?.name);
        formData.append("name_ger", Challenges?.name_ger);
        formData.append("score", Challenges?.score);
        formData.append("benefit", editorState?.content1);
        formData.append("benefit_ger", editorState?.contentData1);
        formData.append("desc", editorState?.content);
        formData.append("desc_ger", editorState?.contentData);
        formData.append("reward", Challenges?.reward);

        const croppedEn = await imageCropEn.getCroppedFile();
        if (croppedEn) formData.append("image", croppedEn);
        const croppedGer = await imageCropGer.getCroppedFile();
        if (croppedGer) formData.append("image_ger", croppedGer);

        await ApiPost(`challenges/create`, formData);
        toast.success("Erfolgreich hinzufügen");
        setAddChallenges(false);
        setIsEditApi(false);
        getAllChallengesData();
        setChallenges({});
        setEditorState({ content: "", contentData: "", contentData1: "", content1: "" });
        imageCropEn.reset();
        imageCropGer.reset();
      } catch (err: any) {
        toast.error(getUploadErrorMessage(err));
      } finally {
        setLoader(false);
      }
    }
  };
  const EditCategoryData = async () => {
    if (formValidation()) {
      setLoader(true);
      try {
        const formData = new FormData();
        formData.append("name", Challenges?.name);
        formData.append("name_ger", Challenges?.name_ger);
        formData.append("score", Challenges?.score);
        formData.append("benefit", editorState?.content1);
        formData.append("benefit_ger", editorState?.contentData1);
        formData.append("desc", editorState?.content);
        formData.append("desc_ger", editorState?.contentData);
        formData.append("reward", Challenges?.reward);

        const croppedEn = await imageCropEn.getCroppedFile();
        if (croppedEn) formData.append("image", croppedEn);
        const croppedGer = await imageCropGer.getCroppedFile();
        if (croppedGer) formData.append("image_ger", croppedGer);
        if (removeImageEn) formData.append("removeImage", "true");
        if (removeImageGer) formData.append("removeImage_ger", "true");

        await ApiPut(`challenges/update?id=${ChallengesIdForEdit}`, formData);
        toast.success("Erfolgreich geupdated");
        getAllChallengesData();
        setAddChallenges(false);
        setIsEditApi(false);
        setChallenges({});
        setEditorState({ content: "", contentData: "", content1: "", contentData1: "" });
        imageCropEn.reset();
        imageCropGer.reset();
        setRemoveImageEn(false);
        setRemoveImageGer(false);
      } catch (err: any) {
        toast.error(getUploadErrorMessage(err));
      } finally {
        setLoader(false);
      }
    }
  };

  // For Delete document Api
  const DeleteCategoryData = async () => {
    await ApiDelete(`challenges/delete?id=${ChallengesIdForDelete}`)
      .then((res: any) => {
        if (res?.status === 200) {
          toast.success("Erfolgreich löschen");
          setShow(false);
          setPage(1);
          getAllChallengesData();
        } else {
          toast.error(res?.data?.message || "Etwas ist schief gelaufen. Bitte versuche es erneut");
        }
      })
      .catch((err: any) => {
        toast.error(getUploadErrorMessage(err));
      });
  };



  const userScoreDataColumns = async (
    userId: string,
    action: "reduce" | "complete",
    challengeId: string
  ) => {
    await ApiGet(
      `challenges/getUserChallenge?id=${challengeId}&userId=${userId}`
    ).then((res: any) => {
      const userChallengeId = res?.data?.challenge?.[0]?._id;
      if (action === "complete") {
        completeChallengeApi(userChallengeId, challengeId);
      } else if (action === "reduce") {
        reduceChallengeApi(userChallengeId, challengeId);
      }
    });
  };

  const completeChallengeApi = async (idx: string, challengeId: string) => {
    const data = {
      challengeId,
    };
    await ApiPost(`challenges/completeChallenge?id=${idx}`, data)
      .then(() => {
        toast.success("Dien-Partitur hinzugefügt");
        getUserdetails(id, modalPage, modalCountPerPage, search1 || "");
      })
      .catch((error: any) => {
        toast.error(error?.response?.data?.message || "Etwas ist schief gelaufen. Bitte versuche es erneut");
      });
  };

  const reduceChallengeApi = async (idx: string, challengeId: string) => {
    const data = {
      challengeId,
    };
    await ApiPost(`challenges/reduceChallenge?id=${idx}`, data)
      .then(() => {
        toast.success("Dien-Partitur abgezogen");
        getUserdetails(id, modalPage, modalCountPerPage, search1 || "");
      })
      .catch((error: any) => {
        toast.error(error?.response?.data?.message || "Etwas ist schief gelaufen. Bitte versuche es erneut");
      });
  };

  const challengeColumns: TableColumnDef[] = [
    {
      header: "Name",
      render: (row: any) => (lang === "de" ? row?.name_ger : row?.name) || "-",
      getValue: (row: any) => lang === "de" ? row?.name_ger : row?.name,
    },
    {
      header: "Bild",
      width: "130px",
      render: (row: any) => (
        <TableThumbnail src={lang === "de" ? row?.image_ger : row?.image} />
      ),
    },
    {
      header: "Punktzahl",
      render: (row: any) => row?.score,
      getValue: (row: any) => row?.score,
    },
    {
      header: "Belohnung",
      render: (row: any) => row?.reward,
      getValue: (row: any) => row?.reward,
    },
    {
      header: "Einstellungen",
      render: (row: any) => (
        <Box sx={{ display: "flex", gap: 0.5 }}>
          {canEdit && (
            <Tooltip title="Bearbeiten" arrow>
              <IconButton
                size="small"
                color="primary"
                onClick={() => {
                  setIsEditApi(true);
                  setAddChallenges(true);
                  setChallengesIdForEdit(row?._id);
                  setChallenges({
                    name: row?.name,
                    image: row?.image,
                    reward: row?.reward,
                    score: row?.score,
                    desc: row?.desc,
                    language: row?.language,
                    benefit: row?.benefit,
                    name_ger: row?.name_ger,
                    image_ger: row?.image_ger,
                    benefit_ger: row?.benefit_ger,
                    desc_ger: row?.desc_ger,
                  });
                  setEditorState({
                    content: row?.desc,
                    content1: row?.benefit,
                    contentData: row?.desc_ger,
                    contentData1: row?.benefit_ger,
                  });
                }}
              >
                <CreateIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          )}
          {canDelete && (
            <Tooltip title="Löschen" arrow>
              <IconButton
                size="small"
                color="error"
                onClick={() => {
                  setChallengesIdForDelete(row?._id);
                  setShow(true);
                }}
              >
                <DeleteIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          )}
          <Tooltip title="Benutzer anzeigen" arrow>
            <IconButton
              size="small"
              color="info"
              onClick={() => {
                setUserDetails(true);
                setId(row?._id);
                setModalLoading(true);
                setgetChallengeId(row?._id);
                setUserScore(row?.score);
              }}
            >
              <InfoIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Box>
      ),
    },
  ];

  const userDatColumns: TableColumnDef[] = [
    {
      header: "Vorname",
      render: (row: any) => row?.userId?.firstName,
      getValue: (row: any) => row?.userId?.firstName,
    },
    {
      header: "Nachname",
      render: (row: any) => row?.userId?.lastName,
      getValue: (row: any) => row?.userId?.lastName,
    },
    {
      header: "E-Mail",
      render: (row: any) => row?.userId?.emailId,
      getValue: (row: any) => row?.userId?.emailId,
    },
    {
      header: "Telefonnummer",
      render: (row: any) => row?.userId?.phoneNo,
      getValue: (row: any) => row?.userId?.phoneNo,
    },
    {
      header: "Dien Keb",
      render: (row: any) => `${row?.userScore}/${userScore}`,
      getValue: (row: any) => row?.userScore,
    },
    {
      header: "Antwort",
      render: (row: any) => (
        <>
          <IconButton
            size="small"
            sx={{ mr: 1 }}
            onClick={() => {
              if (row?.userScore === userScore) {
                toast.error("Challenge-Punktzahl erreicht");
              } else {
                userScoreDataColumns(row?.userId?._id, "complete", getChallengeId);
              }
            }}
          >
            <i
              className="ki ki-plus icon-sm"
              style={{ color: "red" }}
            ></i>
          </IconButton>

          <IconButton
            size="small"
            onClick={() => {
              if (row?.userScore === 0) {
                toast.error("Darf nicht kleiner als 0 sein");
              } else {
                userScoreDataColumns(row?.userId?._id, "reduce", getChallengeId);
              }
            }}
          >
            <i
              className="ki ki-minus icon-sm"
              style={{ color: "red" }}
            ></i>
          </IconButton>
        </>
      ),
    },
  ];

  return (
    <>
      <Paper sx={{ p: 1 }}>
        <ToastContainer />
        <PageHeader
          title="Challenges"
          onSearch={(val) => { setSearch(val); setPage(1); }}
          onAdd={canCreate ? () => {
            setIsEditApi(false);
            setChallenges({});
            setErrors({});
            setEditorState({ content: "", content1: "", contentData: "", contentData1: "" });
            imageCropEn.reset();
            imageCropGer.reset();
            setAddChallenges(true);
          } : undefined}
        />
        <LanguageTabs value={lang} onChange={setLang} />

        {userDetails && (
          <Dialog fullScreen open={userDetails}>
            <AppBar sx={{ position: "relative" }} color="default" elevation={1}>
              <Toolbar>
                <Typography variant="h6" sx={{ flex: 1 }}>
                  Challenge-Benutzer
                </Typography>
                <IconButton
                  edge="end"
                  color="inherit"
                  onClick={() => userDetailsModalClose()}
                  aria-label="close"
                >
                  <CloseIcon />
                </IconButton>
              </Toolbar>
            </AppBar>
            <Box sx={{ p: 3 }}>
              <Box sx={{ width: 320, mb: 2 }}>
                <SearchInput onSearch={(val: any) => { setSearch1(val); setModalPage(1); }} placeholder="Benutzer suchen..." />
              </Box>
              {modalLoading ? (
                <Box sx={{ display: "flex", justifyContent: "center", mt: 2.5 }}>
                  <CircularProgress />
                </Box>
              ) : (
                <DataTable
                  rows={userData || []}
                  columns={userDatColumns}
                  page={modalPage}
                  count={modalCount}
                  rowsPerPage={modalCountPerPage}
                  onPageChange={setModalPage}
                  onRowsPerPageChange={setModalCountPerPage}
                />
              )}
            </Box>
          </Dialog>
        )}

        {loaderForGetAll ? (
          <Box sx={{ display: "flex", justifyContent: "center", mt: 2.5 }}>
            <CircularProgress />
          </Box>
        ) : (
          //Data Table

          <DataTable
            rows={getAllChallenges || []}
            columns={challengeColumns}
            page={page}
            count={count}
            rowsPerPage={countPerPage}
            onPageChange={setPage}
            onRowsPerPageChange={setCountPerPage}
          />
        )}
      </Paper>
      <Dialog open={show} onClose={handleClose}>
        <DialogTitle sx={{ color: "error.main", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          Löschen bestätigen
          <IconButton size="small" onClick={handleClose} aria-label="close">
            <CloseIcon fontSize="small" />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Möchtest du diese Herausforderungen wirklich löschen?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="inherit">
            Nein
          </Button>
          <Button onClick={() => DeleteCategoryData()} color="error" variant="contained">
            Ja
          </Button>
        </DialogActions>
      </Dialog>

      {/* Open add photographer model */}
      {addChallenges === true ? (
        <Dialog fullScreen open={addChallenges}>
          <Toolbar>
            <IconButton
              edge="end"
              color="inherit"
              onClick={() => addChallengesModelClose()}
              aria-label="close"
              sx={{ ml: "auto" }}
            >
              <CloseIcon />
            </IconButton>
          </Toolbar>
          <List>
            <Box sx={{ maxWidth: 1200, mx: "auto", p: 3 }}>
              <Box sx={{ display: "flex", mb: 3, flexWrap: "wrap" }}>
                <Box sx={{ width: { xs: "100%", lg: "16.66%" } }} />
                <Box sx={{ width: { xs: "100%", lg: "41.67%" }, textAlign: "center" }}>
                  <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 1 }}>
                    Deutsch
                  </Typography>
                </Box>
                <Box sx={{ width: { xs: "100%", lg: "41.67%" }, textAlign: "center" }}>
                  <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 1 }}>
                    English
                  </Typography>
                </Box>
              </Box>
              <Box sx={{ display: "flex", mb: 3, flexWrap: "wrap" }}>
                <Typography sx={{ width: { xs: "100%", lg: "16.66%" }, pt: 1 }}>Name</Typography>
                <Box sx={{ width: { xs: "100%", lg: "41.67%" }, pr: 1 }}>
                  <TextField
                    size="small"
                    fullWidth
                    variant="outlined"
                    id="name_ger"
                    name="name_ger"
                    value={Challenges?.name_ger}
                    onChange={(e) => {
                      onhandleChange(e);
                    }}
                  />
                  <Typography variant="caption" color="error">
                    {errors["name_ger"]}
                  </Typography>
                </Box>
                <Box sx={{ width: { xs: "100%", lg: "41.67%" }, pr: 1 }}>
                  <TextField
                    size="small"
                    fullWidth
                    variant="outlined"
                    id="name"
                    name="name"
                    value={Challenges?.name}
                    onChange={(e) => {
                      onhandleChange(e);
                    }}
                  />
                  <Typography variant="caption" color="error">
                    {errors["name"]}
                  </Typography>
                </Box>
              </Box>

              <Box sx={{ display: "flex", mb: 3, flexWrap: "wrap" }}>
                <Typography sx={{ width: { xs: "100%", lg: "16.66%" }, pt: 1 }}>Bild</Typography>
                <Box sx={{ width: { xs: "100%", lg: "41.67%" }, pr: 1 }}>
                  <ImageCropField
                    inputId="image_ger"
                    imageCrop={imageCropGer}
                    existingImage={typeof Challenges?.image_ger === "string" ? Challenges?.image_ger : undefined}
                    error={errors["image_ger"]}
                    onRemoveExistingImage={() => {
                      setChallenges({ ...Challenges, image_ger: "" });
                      setRemoveImageGer(true);
                    }}
                  />
                </Box>
                <Box sx={{ width: { xs: "100%", lg: "41.67%" }, pr: 1 }}>
                  <ImageCropField
                    inputId="imageUpload"
                    imageCrop={imageCropEn}
                    existingImage={typeof Challenges?.image === "string" ? Challenges?.image : undefined}
                    error={errors["image"]}
                    onRemoveExistingImage={() => {
                      setChallenges({ ...Challenges, image: "" });
                      setRemoveImageEn(true);
                    }}
                  />
                </Box>
              </Box>

              <Box sx={{ display: "flex", mb: 3, flexWrap: "wrap" }}>
                <Typography sx={{ width: { xs: "100%", lg: "16.66%" }, pt: 1 }}>
                  Beschreibung (oben)
                </Typography>
                <Box sx={{ width: { xs: "100%", lg: "41.67%" }, pr: 1 }}>
                  <SelfHostedEditor
                    onChange={(_event: any, editor: any) => {
                      setEditorState((prev: any) => ({
                        ...prev,
                        contentData1: editor?.getContent(),
                      }));
                    }}
                    initialValue={Challenges?.benefit_ger}
                  />
                  <Typography variant="caption" color="error">
                    {errors["contentData1"]}
                  </Typography>
                </Box>
                <Box sx={{ width: { xs: "100%", lg: "41.67%" }, pr: 1 }}>
                  <SelfHostedEditor
                    onChange={(_event: any, editor: any) => {
                      setEditorState((prev: any) => ({
                        ...prev,
                        content1: editor?.getContent(),
                      }));
                    }}
                    initialValue={Challenges?.benefit}
                  />
                  <Typography variant="caption" color="error">
                    {errors["content1"]}
                  </Typography>
                </Box>
              </Box>

              <Box sx={{ display: "flex", mb: 3, flexWrap: "wrap" }}>
                <Typography sx={{ width: { xs: "100%", lg: "16.66%" }, pt: 1 }}>
                  Beschreibung (unten)
                </Typography>
                <Box sx={{ width: { xs: "100%", lg: "41.67%" }, pr: 1 }}>
                  <SelfHostedEditor
                    onChange={(_event: any, editor: any) => {
                      setEditorState((prev: any) => ({
                        ...prev,
                        contentData: editor?.getContent(),
                      }));
                    }}
                    initialValue={Challenges?.desc_ger}
                  />
                  <Typography variant="caption" color="error">
                    {errors["contentData"]}
                  </Typography>
                </Box>
                <Box sx={{ width: { xs: "100%", lg: "41.67%" }, pr: 1 }}>
                  <SelfHostedEditor
                    onChange={(_event: any, editor: any) => {
                      setEditorState((prev: any) => ({
                        ...prev,
                        content: editor?.getContent(),
                      }));
                    }}
                    initialValue={Challenges?.desc}
                  />
                  <Typography variant="caption" color="error">
                    {errors["content"]}
                  </Typography>
                </Box>
              </Box>

              <Box sx={{ display: "flex", mb: 3, flexWrap: "wrap" }}>
                <Typography sx={{ width: { xs: "100%", lg: "16.66%" }, pt: 1 }}>
                  Punktzahl
                </Typography>
                <Box sx={{ width: { xs: "100%", lg: "83.33%" } }}>
                  <TextField
                    size="small"
                    fullWidth
                    variant="outlined"
                    type="number"
                    id="score"
                    name="score"
                    value={Challenges?.score}
                    onChange={(e) => {
                      onhandleChange(e);
                    }}
                  />
                  <Typography variant="caption" color="error">
                    {errors["score"]}
                  </Typography>
                </Box>
              </Box>
              <Box sx={{ display: "flex", mb: 3, flexWrap: "wrap" }}>
                <Typography sx={{ width: { xs: "100%", lg: "16.66%" }, pt: 1 }}>
                  Belohnung
                </Typography>
                <Box sx={{ width: { xs: "100%", lg: "83.33%" } }}>
                  <TextField
                    size="small"
                    fullWidth
                    variant="outlined"
                    type="number"
                    id="reward"
                    name="reward"
                    value={Challenges?.reward}
                    onChange={(e) => {
                      onhandleChange(e);
                    }}
                  />
                  <Typography variant="caption" color="error">
                    {errors["reward"]}
                  </Typography>
                </Box>
              </Box>
            </Box>

            <Box sx={{ display: "flex", justifyContent: "center" }}>
              {loader ? (
                <Button variant="contained" disabled>
                  {isEditApi ? "Speichern" : "Hinzufügen"}
                  <CircularProgress size={20} sx={{ ml: 2 }} />
                </Button>
              ) : (
                <Button
                  variant="contained"
                  onClick={() => {
                    isEditApi ? EditCategoryData() : addCategoryData();
                  }}
                >
                  {isEditApi ? "Speichern" : "Hinzufügen"}
                </Button>
              )}
            </Box>
          </List>
        </Dialog>
      ) : null}
    </>
  );
}
